
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "CommentableUnion": [
      "LineItem",
      "Order"
    ],
    "ElasticHitSourceUnion": [
      "DashboardCartonGrouping",
      "DashboardContainer",
      "DashboardLocation"
    ],
    "MapPointLocatableUnion": [
      "FoodBusinessOperator",
      "SeaPort",
      "Vessel"
    ],
    "MasterfileEntityUnion": [
      "CompanyAssociation",
      "FarmVariety",
      "FoodBusinessOperator",
      "PackhouseConnection"
    ],
    "MasterfileFarmVariety": [
      "FarmVariety",
      "FarmVarietyRequest"
    ],
    "MasterfileFoodBusinessOperator": [
      "FoodBusinessOperator",
      "FoodBusinessOperatorRequest"
    ],
    "NotifiableUnion": [
      "Comment"
    ],
    "ProfitAndLossReportOutcomeUnion": [
      "ProfitAndLossReportCompleted",
      "ProfitAndLossReportError",
      "ProfitAndLossReportNotFound",
      "ProfitAndLossReportPending"
    ]
  }
};
      export default result;
    